import { createFileRoute } from "@tanstack/react-router";
import { redirectIntoScope } from "@/app/router/legacy-redirect";

/** Old unscoped URL: `/conversations/…` → `/{store}/conversations/…`. */
export const Route = createFileRoute("/conversations/$")({ beforeLoad: redirectIntoScope });
